import { sharedTheme } from "@eurodrive/ui"
import { createTheme, ThemeOptions } from "@mui/material/styles"
import sharedColors from "./colors"

const customTheme = createTheme({
  ...sharedTheme,
} as ThemeOptions)

export const theme = {
  ...customTheme,
  sharedColors,
} as const

export type Theme = typeof theme
